import { convertFromRaw, EditorState } from 'draft-js';
import parseJsonIfValid from '../../utils/parseJsonIfValid';
import { editorDecorator } from '../Collaboration/utils';

/**
 * In old way, we were using Text editor for incident descriptions.
 * We are storing it as JSON with data structure inside.
 * However, as all other entity descriptions in Kubit,
 * description should be a plain string.
 * This parser will parse JSON Text editor value
 * and will always output a string
 */
export const parseIncidentDescription = (description?: string): string => {
  if (!description) {
    return '';
  }

  const parsedJson = parseJsonIfValid(description);

  if (parsedJson === null) {
    return description;
  }

  try {
    // XXX There are many ways to supply some valid JSON which won't parse correctly
    // (e.g. just a number). The alternative (to this try/catch) is to try to positively
    // validate that the parsedJson is actually saved editor state before trying to use it
    const parsed = EditorState.createWithContent(
      convertFromRaw(parsedJson),
      editorDecorator({}),
    );

    const editorContent = parsed.getCurrentContent();
    return editorContent.getPlainText().trim();
  } catch {
    console.debug(
      'Failed to extract description from EditorState json (fall-back to raw description)',
      parsedJson,
    );
    return description;
  }
};
